import useApi from "./useApiRequest";
import { useMutation } from "react-query";


export const DeleteSubAlmacen = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/almacenes/subalmacenes/delete/${params}`, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        deleteSubAlmacenMutation: mutation.mutate,
    };
}